import { ActionTypes } from "../../constants/action-types";

const initialState = {
    is_connections: false,
    is_profile_connectons: false,

    connections: [],
    profileConnections: [],

    acceptConectionRequests: [],
    pendingConnectionRequests: [],

    acceptProfileConectionRequests: [],
    pendingProfileRequests: [],

    inYourProfessionalPeer: [],
    suggestedContacts: [],

    myContacts: [],
    locationMap: [],

    requestedReferences: [],
    myReferences: [],


};


export const networkreducer = (state = initialState, { type, payload }) => {
    switch (type) {

        case ActionTypes.SET_MY_CONNECTIONS:
            return {
                ...state,
                is_connections: true,
                connections: payload,
            };

        case ActionTypes.ADD_MY_CONNECTION:
            return {
                ...state,
                connections: [...state.connections, payload[0]],
            };

        // Profile Connections
        case ActionTypes.SET_ACCEPT_PROFILE_CONNECTION:
            return {
                ...state,
                acceptProfileConectionRequests: payload,
            };

        case ActionTypes.REMOVE_ACCEPT_PROFILE_CONNECTION:
            return {
                ...state,
                acceptProfileConectionRequests: [
                    ...state.acceptProfileConectionRequests.filter(
                        (val) => val !== payload[0]
                    ),
                ],
            };

        case ActionTypes.SET_PROFILE_CONNECTIONS:
            return {
                ...state,
                is_profile_connectons: true,
                profileConnections: payload,
            };

        case ActionTypes.ADD_MY_PROFILE_CONNECTION:
            return {
                ...state,
                profileConnections: [...state.profileConnections, payload[0]],
            };

        case ActionTypes.REMOVE_PENDING_PROFILE_CONNECTION:
            return {
                ...state,
                pendingProfileRequests: [
                    ...state.pendingProfileRequests.filter((val) => val.id !== payload),
                ],
            };

        // Connection Requests
        // Accept connecton requests
        case ActionTypes.SET_ACCEPT_CONNECTION_REQUESTS:
            return {
                ...state,
                acceptConectionRequests: payload,
            };

        case ActionTypes.REMOVE_ACCEPT_REQUEST:
            return {
                ...state,
                acceptConectionRequests: [
                    ...state.acceptConectionRequests.filter(
                        (val) => val !== payload[0]
                    ),
                ],
            };

        // My pending requests
        case ActionTypes.SET_PENDING_CONNECTION_REQUESTS:
            return {
                ...state,
                pendingConnectionRequests: payload,
            };

        case ActionTypes.ADD_PENDING_REQUEST:
            return {
                ...state,
                pendingConnectionRequests: [...state.pendingConnectionRequests, payload[0]],
            };

        case ActionTypes.REMOVE_PENDING_CONNECTION:
            return {
                ...state,
                pendingConnectionRequests: [
                    ...state.pendingConnectionRequests.filter(
                        (val) => val.id !== payload
                    ),
                ],
            };

        // My profile pending requests
        case ActionTypes.SET_PENDING_PROFILE_REQUESTS:
            return {
                ...state,
                pendingProfileRequests: payload,
            };

        // Grow your contacts
        // In your profession connection
        case ActionTypes.SET_YOUR_PROFESSION_PEERS:
            return {
                ...state,
                inYourProfessionalPeer: payload,
            };

        case ActionTypes.REMOVE_PROFESSION_CONNECTION:
            return {
                ...state,
                inYourProfessionalPeer: [
                    ...state.inYourProfessionalPeer.filter((val) => val !== payload[0]),
                ],
            };

        // Suggested contacts
        case ActionTypes.SET_SUGGESTED_CONTACTS:
            return {
                ...state,
                suggestedContacts: payload,
            };

        case ActionTypes.ADD_SUGGESTION_CONTACT:
            return {
                ...state,
                suggestedContacts: [...state.suggestedContacts, payload[0]],
            };

        case ActionTypes.REMOVE_SUGGESTION_CONNECTION:
            return {
                ...state,
                suggestedContacts: [
                    ...state.suggestedContacts.filter((val) => val !== payload[0]),
                ],
            };

        // My Contacts
        case ActionTypes.SET_MY_CONTACTS:
            return {
                ...state,
                myContacts: payload,
            };

        // My contacts by location
        case ActionTypes.SET_LOCATION_MAP:
            return {
                ...state,
                locationMap: payload,
            };

        // References
        case ActionTypes.SET_REQUESTED_REFERENCE:
            return {
                ...state,
                requestedReferences: payload,
            };

        case ActionTypes.REMOVE_REQUESTED_REFERENCE:
            return {
                ...state,
                requestedReferences: [
                    ...state.requestedReferences.filter((val) => val !== payload[0]),
                ],
            };

        case ActionTypes.SET_MY_REFERENCES:
            return {
                ...state,
                myReferences: payload,
            };

        case ActionTypes.RESET_STORE:
            return {
                ...(state = initialState),
            };
        default:
            return state;
    }
};
